import { useNavigate } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { AuthFormBox } from './__styled'
import { IMAGES } from '@/assets/images'
import { Box } from '@mui/system'
import SVG from 'react-inlinesvg'
import { SVGS } from '@/assets/svgs'
import colors from '@/styles/colors'

export default function ForgotForm3() {
  const navigate = useNavigate()
  const onSignIn = () => {
    navigate('/login')
  }
  return (
    <AuthFormBox>
      <Box mb={3}>
        <SVG src={SVGS.LockSuccessIcon} className='forgot-success' color={colors.successGreen} />
      </Box>
      <Typography
        fontWeight={700}
        fontSize={{ xs: 32, md: 36 }}
        color='#0f172a'
        lineHeight={1.2}
        sx={{ letterSpacing: '-0.02em', mb: 1.5 }}
      >
        Password Successfully Reset
      </Typography>
      <Typography
        variant='p'
        fontSize={16}
        color='#64748b'
        lineHeight={1.6}
        mt={'12px'}
        mb={3}
        style={{ whiteSpace: 'pre-line' }}
      >
        Your password has been successfully reset. Click below to sign in with your new password.
      </Typography>
      <Button
        variant='contained'
        size='large'
        fullWidth
        onClick={onSignIn}
        sx={{
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          borderRadius: '12px',
          textTransform: 'none',
          fontWeight: 600,
          fontSize: '16px',
          letterSpacing: '-0.01em',
          py: '14px',
          mt: 1,
          boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            background: 'linear-gradient(135deg, #5558e3 0%, #7c4ee8 100%)',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 24px rgba(99, 102, 241, 0.4)',
          },
          '&:active': {
            transform: 'translateY(0px)',
          },
        }}
      >
        Sign In
      </Button>
    </AuthFormBox>
  )
}
